import { inject, Injectable } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import {
  OverviewLocationsGuard,
  OverviewStatisticsGuard,
  OverviewCartsGuard,
  OverviewWitnessGuard,
  OverviewActionsGuard,
} from './guards';

export interface OverviewUiRoute {
  path: string;
  name: string;
  icon: string;
  suffix?: { color: ThemePalette; text: string; value: number };
  desc: string;
}

@Injectable({ providedIn: 'root' })
export class OverviewRoutePermissionsService {
  private readonly overviewLocationsGuard = inject(OverviewLocationsGuard);
  private readonly overviewStatisticsGuard = inject(OverviewStatisticsGuard);
  private readonly overviewCartsGuard = inject(OverviewCartsGuard);
  private readonly overviewWitnessGuard = inject(OverviewWitnessGuard);
  private readonly overviewActionGuard = inject(OverviewActionsGuard);

  private readonly store = inject(Store);

  getAllowedRoutes(): Observable<OverviewUiRoute[]> {
    return combineLatest([
      this.overviewStatisticsGuard.canMatch(),
      this.overviewLocationsGuard.canMatch(),
      this.overviewCartsGuard.canMatch(),
      this.overviewWitnessGuard.canMatch(),
      this.overviewActionGuard.canMatch(),
    ]).pipe(
      map(
        ([
          overviewStatisticsGuard,
          overviewLocationsGuard,
          overviewCartsGuard,
          overviewWitnessGuard,
          overviewActionGuard,
        ]) => {
          const routes: OverviewUiRoute[] = [];
          if (overviewStatisticsGuard) {
            routes.push({
              path: 'statistics',
              name: 'Statistics',
              icon: 'statistics',
              desc: 'Dashboard',
              suffix: { color: 'primary', value: 0, text: 'New' },
            });
          }
          if (overviewCartsGuard) {
            routes.push({
              path: 'views',
              name: 'VIEW Carts',
              icon: 'views',
              desc: 'System Status',
              suffix: { color: 'primary', value: 0, text: 'New' },
            });
          }
          if (overviewLocationsGuard) {
            routes.push({
              path: 'locations',
              name: 'Locations',
              icon: 'locations',
              desc: 'Organization Overview',
              suffix: { color: 'primary', value: 0, text: 'New' },
            });
          }
          if (overviewWitnessGuard) {
            routes.push({
              path: 'anytimewitness',
              name: 'Anytime Witness',
              icon: 'anytimewitness',
              desc: 'Witness Pending Wastes',
              suffix: { color: 'primary', value: 0, text: 'New' },
            });
          }
          if (overviewActionGuard) {
            routes.push({
              path: 'actions',
              name: 'Actions',
              icon: 'actions',
              desc: 'Action Items',
              suffix: { color: 'primary', value: 0, text: 'New' },
            });
          }
          return routes;
        },
      ),
    );
  }
}
